import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, testid }) {
  return (
    <Link
      to={`/products/${product.id}`}
      data-testid={testid || `product-card-${product.sku}`}
      className="group relative flex flex-col border border-black/10 bg-white transition-colors duration-300 hover:border-gavra"
    >
      <div className="relative aspect-square overflow-hidden spotlight">
        {product.image_url && (
          <img
            src={product.image_url}
            alt={product.name}
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        )}
        <span className="absolute right-0 top-0 bg-white/90 backdrop-blur px-2 py-1 font-mono-hw text-[10px] font-bold uppercase tracking-wider text-black/60">
          {product.sku}
        </span>
        <div className="absolute inset-0 flex items-end justify-center bg-black/0 opacity-0 transition-all duration-300 group-hover:bg-black/70 group-hover:opacity-100">
          <span className="mb-8 flex items-center gap-2 bg-gavra px-5 py-3 text-[12px] font-bold uppercase tracking-[0.15em] text-white">
            View Details <ArrowUpRight className="h-4 w-4" />
          </span>
        </div>
      </div>
      <div className="flex items-start justify-between gap-3 border-t border-black/10 p-5">
        <div className="min-w-0">
          <p className="font-mono-hw text-[10px] uppercase tracking-widest text-gavra">{product.category}</p>
          <h3 className="mt-1 truncate font-heading text-lg font-bold text-black">{product.name}</h3>
        </div>
        <span className="shrink-0 font-mono-hw text-[10px] uppercase tracking-widest text-black/40">{product.sku}</span>
      </div>
    </Link>
  );
}
